import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, absUrl } from "@/lib/api";
import { timeAgo } from "@/lib/constants";
import { MessageCircle } from "lucide-react";

export default function Messages() {
    const [convs, setConvs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/messages/conversations");
                setConvs(data);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    return (
        <div className="min-h-screen bg-onyx-900">
            <div
                className="sticky top-0 z-30 backdrop-blur-xl border-b border-onyx-600"
                style={{ background: "rgba(10,10,10,0.85)" }}
            >
                <div className="max-w-3xl mx-auto px-4 py-3">
                    <div className="headline text-2xl">Messages</div>
                </div>
            </div>

            <div className="max-w-3xl mx-auto px-4 py-4">
                {loading ? (
                    Array.from({ length: 3 }).map((_, i) => (
                        <div key={i} className="surface rounded-md p-4 mb-2 flex gap-3 items-center">
                            <div className="w-12 h-12 rounded-full bg-onyx-800 animate-pulse" />
                            <div className="flex-1 space-y-2">
                                <div className="h-3 w-1/3 bg-onyx-800 animate-pulse rounded" />
                                <div className="h-3 w-2/3 bg-onyx-800 animate-pulse rounded" />
                            </div>
                        </div>
                    ))
                ) : convs.length === 0 ? (
                    <div className="surface rounded-md p-10 text-center">
                        <MessageCircle className="w-10 h-10 mx-auto text-onyx-500 mb-3" />
                        <div className="headline text-xl">No messages yet</div>
                        <div className="text-sm text-onyx-500 mt-1">
                            Message a seller from a listing to start a conversation.
                        </div>
                    </div>
                ) : (
                    <div className="space-y-2">
                        {convs.map((c) => (
                            <Link
                                to={`/messages/${c.conversation_id}`}
                                key={c.conversation_id}
                                className="surface rounded-md p-4 flex gap-3 items-center hover:border-hellcat"
                                style={{ transition: "border-color 0.15s" }}
                                data-testid={`conv-${c.conversation_id}`}
                            >
                                <div className="w-12 h-12 rounded-full surface-elevated overflow-hidden shrink-0 flex items-center justify-center">
                                    {c.other_user?.avatar_url ? (
                                        <img
                                            src={absUrl(c.other_user.avatar_url)}
                                            className="w-full h-full object-cover"
                                            alt=""
                                        />
                                    ) : (
                                        <span className="label-caps text-onyx-500">
                                            {c.other_user?.name?.[0] || "?"}
                                        </span>
                                    )}
                                </div>
                                <div className="flex-1 min-w-0">
                                    <div className="flex items-center justify-between gap-2">
                                        <div className="headline text-base truncate">
                                            {c.other_user?.name || "User"}
                                        </div>
                                        <div className="text-[10px] text-onyx-500 label-caps shrink-0">
                                            {timeAgo(c.last_message_at)}
                                        </div>
                                    </div>
                                    <div className="text-sm text-onyx-500 truncate">
                                        {c.last_message_preview || "(no messages yet)"}
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
